import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function ChartPieIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M17.8189 1C17.3332 1 16.9402 1.39295 16.9402 1.87856V14.237C16.9402 14.7226 17.3332 15.1156 17.8189 15.1156H30.1211C30.6068 15.1156 30.9998 14.7226 30.9998 14.237C30.9998 6.97001 25.0873 1 17.8189 1Z"
        fill="currentColor"
      />
      <path
        d="M19.4409 29.0301L15.1768 17.6034V5.4631C15.1768 4.97749 14.7838 4.58454 14.2981 4.58454C7.02972 4.58454 1 10.496 1 17.763C1 25.03 7.02972 31 14.2981 31C15.8891 31 17.4466 30.7177 18.9269 30.1617C19.3809 29.991 19.6108 29.4848 19.4409 29.0301Z"
        fill="currentColor"
      />
      <path
        d="M30.1213 16.8844H17.8191C17.5307 16.8844 17.2613 17.026 17.0965 17.2628C16.9326 17.4996 16.8949 17.8016 16.9961 18.0718L21.3159 29.6478C21.3983 29.8658 21.5631 30.0425 21.7759 30.1386C21.9889 30.2354 22.2288 30.2436 22.4487 30.1609C27.5632 28.2365 31 23.2197 31 17.763C31 17.2774 30.607 16.8844 30.1213 16.8844Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
